class NewsletterOverlayDrawer extends HTMLElement {
    constructor() {
        super();

        this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
        this.querySelector('#NewsletterOverlayDrawer-Overlay').addEventListener('click', this.close.bind(this));

        this.setHeaderLinkAccessibility();
    }

    setHeaderLinkAccessibility() {
        /* Logic */
        const _options = JSON.parse(document.querySelector('newsletter-overlay').getAttribute('data-section-settings'));
        if((typeof _options !== 'undefined' && !_options['showOnlyOnce']) || (_options['showOnlyOnce'] && this.getCookie('nl_overlay') === null )) {
            if(typeof _options['apparitionDelay'] !== 'undefined') {
                setTimeout(this.open.bind(this), _options['apparitionDelay'] * 1000);
            } else {
                this.open();
            }
        }
        /* Logic */
    }

    open() {
        /* Custom Scrollbar - create */
        // if(matchMedia('(hover: hover), (pointer: fine)').matches && !Scrollbar.has(document.querySelector('country-drawer #selectCountryWrapper'))) CountryDrawerScrollbar = Scrollbar.init(document.querySelector('country-drawer #selectCountryWrapper'));
        /* Custom Scrollbar - create */
        // here the animation doesn't seem to always get triggered. A timeout seem to help
        setTimeout(() => {this.classList.add('animate', 'active')});

        this.addEventListener('transitionend', () => {
            const containerToTrapFocusOn = this.classList.contains('is-empty') ? this.querySelector('.drawer__inner-empty') : document.getElementById('NewsletterOverlayDrawer');
            const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
            trapFocus(containerToTrapFocusOn, focusElement);
        }, { once: true });

        document.body.classList.add('overflow-hidden');
        document.documentElement.classList.add('newsletter-overlay-open');

        /* Logic */
        this.updateCookie('nl_overlay','1',false);
        /* Logic */
    }

    close() {
        this.classList.remove('active');
        removeTrapFocus(this.activeElement);
        document.body.classList.remove('overflow-hidden');
        document.documentElement.classList.remove('newsletter-overlay-open');
        /* Custom Scrollbar - go up */
        // if(typeof Scrollbar !== 'undefined' && typeof Scrollbar.get(document.querySelector('cart-drawer-items')) !== 'undefined') setTimeout(() => {Scrollbar.get(document.querySelector('cart-drawer-items')).scrollTop = 0});
        /* Custom Scrollbar - go up */
        /* Logic */
        //if(event.target.matches('.newsletter-overlay-drawer__overlay')) return;
        //this.updateCookie('nl_overlay','1',false);
        /* Logic */
    }

    clearCookie(key) {
        this.updateCookie(key,'',true)
    }

    updateCookie(key,value,deleteCookie) {
        const domain = _staging ? 'redemption-officialstore.myshopify.com/' : 'redemption.com';
        let expires = '';
        if(deleteCookie) {
            let d = new Date;
            d.setTime(d.getTime() + 24*60*60*1000*-1);
            expires = `;expires=${d.toGMTString()}`;
        }
        document.cookie = `${key}=${value};path=/;domain=${domain}${expires}`;
    }

    getCookie(name) {
        const v = document.cookie.match('(^|;) ?' + name + '=([^;]*)(;|$)');
        return v ? v[2] : null;
    }

}

customElements.define('newsletter-overlay', NewsletterOverlayDrawer);